import React from "react"

const monthdata2 = [
    {
        id: 0,
        value: "Nov"
    },
    {
        id: 1,
        value: "Dec"
    },    {
        id: 2,
        value: "Jan"
    },
]

export default monthdata2;
